

export default {
  banner: {
    bannerTitle: "Annual DSI Conference 2024",
    bannerDate: "Friday 12th of January 2024",
    bannerSubmit: "SUBMIT YOUR PAPER",
  },

  about: {
    aboutTitle: "Why attend our conference?",

    aboutContent: "The conference on Digital Service Innovation is organized by students of Digital Service Innovation Halmstad University. The conference is done by students showcasing their knowledge on writing and reviewing academic texts in the field of Informatics",

    aboutContentDescription: {

      goal: `TThe conference aims to bridge a gap in the information on DSI research, inform about the latest issues, and make knowledge available to everyone. `,

      speakers: `How you transform your business as technology, consumer, habits industry dynamic`,

      discover: `Discover some of the most recent trends in Digital Service Innovation Research. Learn more about our tracks.`,

      learn: `The different tracks and papers presented will give an insight into some of the students’ most recent issues and research.`,

      GetNewInsights: `The conference covers a broad range of interesting emerging technologies. The students have done justice in the research work and are showcasing different insights from these technologies.`,

      Networking: `The conference will bring together researchers in the Informatics industry.`

    },
  },

  contact: {
    title: 'REACH US',
    location: 'Get Direction to the Event Location',
    contactInfo: {
      venue: "Halmstad University, Sweden. Kristian IV:s väg 3, 301 18 Halmstad",
      date: '12th January 2024',
      time: '10:00 am',
      direction: 'The venue is in Building S of the University. Building S is directly behind the service center building.'
    }
  },

  trackInfo: [
    {
      track: "Track 1 - AI, Healthcare and Education I",
      trackchair: "Track chair: Jonas Sjöström",
      trackDescription: `Artificial Intelligence (AI) has become a transformative force in healthcare and education, revolutionizing how we approach diagnosis, treatment and learning. `,
      trackQuestions: `How can AI support diverse learning styles and individualized student needs?
                       In what ways can AI enhance accuracy and efficiency in medical diagnoses?
      `,
      trackMore: "Find out more about these topics during the track speeches"
    },
    {
      track: "Track 2 - AI, Healthcare and Education II",
      trackchair: "Track chair: Ahmad Ghazawneh",
      trackDescription: `Artificial Intelligence (AI) is reshaping healthcare and education, fundamentally changing our methods for diagnosing, treating, and acquiring knowledge.`,
      trackQuestions: `How does AI enhance collaborative learning and interactive educational experiences?
                       How can AI be integrated into the existing healthcare ecosystem, and what is the role of healthcare professionals in this integration?
      `,
      trackMore: "During the track, we can see more about these topics"
    },
    {
      track: "Track 3 - Blockchain, Fintech and Big Data",
      trackchair: "Track chair: Eric Dutt",
      trackDescription: `Blockchain, a decentralized and tamper-resistant ledger technology, underpins many innovative applications, including fintech, which leverages cutting-edge financial technologies to enhance and streamline financial services. 
                         Big data complements these advancements by providing the means to process and analyze vast datasets, unlocking valuable insights. `
      ,
      trackQuestions: `How does blockchain work?
                       What is the concept of real-time analytics in the context of big data?`,
      trackMore: "Let’s see more about these topics in the track speeches"
    },
    {
      track: "Track 4 - Digitalization, Society, IOT and Sustainability",
      trackchair: "Track chair:  Amir Zadeh",
      trackDescription: `The convergence of digitalization, society, and the Internet of Things (IoT) holds immense potential for advancing sustainability on a global scale. As our world becomes increasingly interconnected, leveraging digital technologies and IoT solutions can enhance efficiency in resource utilization, promote smart infrastructure, and empower communities to make informed decisions about their environmental impact.`,
      trackQuestions: `How does digitalization impact social structures and interactions within communities?
                       In what industries and sectors can IoT play a significant role in achieving sustainable practices and goals?
                       How can digital technologies be employed to monitor and manage environmental sustainability efforts?`,
      trackMore: "During this track, find out more about these topics"
    },

  ],
  callForPaper: {
    paperHeading: "6th Annual Conference on Digital Service Innovation (DSI 2024) Halmstad, Sweden",
    represent: "Dear Colleagues:",
    paperDescription: `You are invited to submit a paper for inclusion in the 6th Conference on Digital Service Innovation (DSI 2024). The conference welcomes systematic literature reviews conducted in different tracks of Digital service innovation. The conference is organized by master students of Digital Service Innovation as a requisite for the course Academic Communication and Digital Service Innovation Research. 
                      You can submit your paper  `,
    importantDatesForAuthorsTitle: 'Important Dates for authors',
    importantDatesForAuthorsContents:
    {
      conferenceDate: 'Conference Date: 12 January, Friday 10:00 - 14:00',
      FinalArticleSubmissionToTheSystem: 'Final article submission to the system: Monday 08 January by 23:59',
      ArticleReviewDeadline: 'Article Review Deadline: Wednesday 10 Jan by 23:59'
    },
    GeneralSubmissionInformation:
    {
      GeneralSubmissionInformationTitle: 'General Submission Information:',
      GeneralSubmissionInformation1: 'All submissions must be made through the EasyChair submission system.',
      GeneralSubmissionInformation2: 'All submissions must follow the research template uploaded on blackboard',
      GeneralSubmissionInformation3: 'All submissions should be a maximum of 7 pages (excluding abstract, references and keywords)',
      GeneralSubmissionInformation4: 'All authors should ensure that their abstract is a maximum of 200 words and their submission has at least 3 keywords.',
      GeneralSubmissionInformation5: 'All submissions should be submitted as a pdf file.',
      GeneralSubmissionInformation6: 'As the language of the conference is English, all articles are to be written in English',
      GeneralSubmissionInformation7: 'For initial submissions, the name of the authors should not be stated in the paper. After the notification of acceptance, the author names can be included.',
    }
  }
};





